export class MeshSize
{
    private constructor(public width:number,
                        public height:number)
    {
    }

    public static from(width:number, height:number):MeshSize
    {
        return new MeshSize(width, height);
    }

    public static zero():MeshSize
    {
        return new MeshSize(0, 0);
    }
}
